// extracted by mini-css-extract-plugin
var _1 = "Uj03YV";
var _2 = "fTqtpq";
var _3 = "f_Ojb2";
var _4 = "TMaZKx";
var _5 = "ghkmrW";
var _6 = "QJwzbC";
var _7 = "OmSqA8";
var _8 = "duKcHz";
var _9 = "b8MG6d";
export { _1 as "ease-transition", _2 as "gradient-titanic-80", _3 as "linear-transition-05", _4 as "shadow-medium-titanic", _5 as "shadow-medium-titanic-hover", _6 as "shadow-titanic-1", _7 as "shadow-white", _8 as "tabs", _9 as "tabsContainer" }
